import React, { useState, useEffect, ReactNode } from 'react';

import ItemPresentationHistory from '../../../app/components/ItemPresentationHistory';
import { useSnrwbCore } from '../../../common/hooks/useSnrwbCore';
import { CreateUpdateOrganizationDto } from '../../../common/snrwbCore/autogenerated/snrwbApiClient';
import * as OrganizationContext from '../../../common/snrwbCore/contexts/OrganizationContext';

interface ObjectHistoryDetailsForOrganizationProps {
  value: CreateUpdateOrganizationDto;
  prevValue: CreateUpdateOrganizationDto;
}

export const ObjectHistoryDetailsForOrganization: React.FC<ObjectHistoryDetailsForOrganizationProps> =
  props => {
    const [organizationPresentation, setOrganizationPresentation] = useState<
      {
        name: string;
        value: ReactNode;
        prevValue: ReactNode;
        equal: boolean;
      }[]
    >();

    const snrwb = useSnrwbCore();

    useEffect(() => {
      if (props.value) {
        OrganizationContext.OrganizationToPresentHistoryWithPrev(
          snrwb,
          props.value,
          props.prevValue,
        ).then(presentInfo => {
          setOrganizationPresentation(presentInfo);
        });
      }
    }, [props.prevValue, props.value, snrwb]);

    return (
      <>
        {organizationPresentation && (
          <ItemPresentationHistory item={organizationPresentation} />
        )}
      </>
    );
  };
